import type { TrackDto, TrackSessionDto } from '../api/apiTypes'
import type { Lap } from '../domain/lap/Lap'
import { processTrackSessionWithTrackDto } from '../processors/pipeline'
import type { StageExecutionInfo } from '../processors/pipeline/ProcessingPipeline'

export interface SessionLaps {
  laps: Lap[]
  stages: StageExecutionInfo[]
}

export async function processSessionLaps(
  sessionDto: TrackSessionDto,
  trackDto: TrackDto
): Promise<SessionLaps> {
  const hasFinishLine = trackDto.finishLine && trackDto.finishLine.length >= 1
  const result = await processTrackSessionWithTrackDto(
    sessionDto,
    trackDto,
    undefined,
    hasFinishLine ? { skipLapStages: true } : undefined
  )
  const trackSession = result.trackSession
  if (hasFinishLine) {
    trackSession.applyStartFinishForSession(
      0,
      trackDto.finishLine.map((c) => ({
        latitude: c.latitude,
        longitude: c.longitude,
      }))
    )
  }
  return { laps: trackSession.laps, stages: result.processingMetadata.stages }
}
